import { Routes, Route, Navigate } from 'react-router-dom';
import PageWrapperMain from '../../components/page-wrappers/PageWrapperMain';
import SubPageContentHolder from '../../components/subPageContentHolder/SubPageContentHolder';
import ActionQueue from './actionQueue/ActionQueue';
import ActionHistory from './actionHistory/ActionHistory';
import ActionSettings from './actionSettings/ActionSettings';
import ActionRules from './actionSettings/ActionRules';

const ActionsPage = () => {
  return (
    <PageWrapperMain>
      <div className='subPage'>
        <SubPageContentHolder>
          <Routes>
            <Route path='queue' element={<ActionQueue />} />
            <Route path='history' element={<ActionHistory />} />
            <Route path='settings' element={<ActionSettings />} />
            <Route path='rules' element={<ActionRules />} />
            <Route path='*' element={<Navigate to='queue' />} />
          </Routes>
        </SubPageContentHolder>
      </div>
    </PageWrapperMain>
  );
};

export default ActionsPage;
